// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"31e25886","455":"cbee2eee","977":"8d4045cd"}[chunkId] + ".chunk.js";
};